import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { getUrls } from "services/api.enums";

export const filterDesOrganization: AsyncThunk<{}, {}, {}> =
  createAsyncThunk("desOrganization",  async (body: any) => {
      const data = await filterTableDataAPI(
        "/consignment-api/anomalyRequest/v1/s0/grid",
        body.pageNumber,
        { ...body, pageNumber: undefined, pageSize: undefined },
        true,
        10,
        false
      )

      return data.data.response
    
  })

const initialState: any = {
  desOrganizationData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const DesOrganizationSlice = createSlice({
  initialState: initialState,
  name: "desOrganization",
  reducers: {
    clearDesOrganization: (state) => {
      state.desOrganizationData = [];
    },
    setFilterDesorganization: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterDesOrganization.fulfilled as any]: (state, action) => {
      state.desOrganizationData = action.payload;
      state.fetchpost = false;
    },
    [filterDesOrganization.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterDesOrganization.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterDesorganization, clearDesOrganization } =
  DesOrganizationSlice.actions;
export default DesOrganizationSlice.reducer;
